import React from 'react';
import ProfileImage from "../../../../components/profileImage";

const EventMembers = ({ event, handleAttendanceStatusChange }) => {
  // Ensure members is an array
  const members = Array.isArray(event.members) ? event.members : [];
  
  if (members.length === 0) {
    return (
      <div>
        <h4 className="text-lg font-medium text-red-500 text-center mt-10 mb-3">
          No participants found
        </h4>
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-xl font-semibold text-gray-900 mb-4">
        Participants
      </h3>

      {/* Supervisors Section */}
      <div className="mb-6">
        <h4 className="text-lg font-medium text-gray-800 mb-3">
          Supervisors
        </h4>
        <div className="bg-gray-50 rounded-xl p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {members
              .filter((member) => member.accountType === "supervisor")
              .map((member) => (
                <MemberCard 
                  key={member.userId} 
                  member={member} 
                  event={event}
                  handleAttendanceStatusChange={handleAttendanceStatusChange}
                />
              ))}
          </div>
        </div>
      </div>

      {/* Players Section */}
      <div>
        <h4 className="text-lg font-medium text-gray-800 mb-3">
          Players
        </h4>
        <div className="bg-gray-50 rounded-xl p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {members
              .filter((member) => member.accountType === "player")
              .map((member) => (
                <MemberCard 
                  key={member.userId} 
                  member={member} 
                  event={event}
                  handleAttendanceStatusChange={handleAttendanceStatusChange}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const MemberCard = ({ member, event, handleAttendanceStatusChange }) => (
  <div className="flex items-center justify-between bg-white p-4 rounded-lg border border-gray-100">
    <div>
      <ProfileImage
        image={member.user.profilePicture}
        className="w-10 h-10 rounded-full"
      />
      <p className="font-medium text-gray-900">
        {member.user.firstName} {member.user.lastName}
      </p>
      <p className="text-sm text-gray-500 capitalize">
        {member.user.userName}
      </p>
      <p className="text-sm text-gray-500 capitalize">
        {member.user.email}
      </p>
      <p className="text-sm text-gray-500 capitalize">
        {member.accountType}
      </p>
    </div>
    <div className="flex items-center space-x-2">
      {event.event.eventStatus === "In Progress" || event.event.eventStatus === "Completed" ? (
        <select
          value={member.attendanceStatus}
          onChange={(e) => handleAttendanceStatusChange(member.userId, e.target.value)}
          className={`px-3 py-1 rounded-full text-sm border ${
            member.attendanceStatus === "pending"
              ? "bg-yellow-50 text-yellow-700 border-yellow-200"
              : member.attendanceStatus === "attended"
              ? "bg-green-50 text-green-700 border-green-200"
              : "bg-red-50 text-red-700 border-red-200"
          }`}
        >
          <option value="pending">Pending</option>
          <option value="attended">Attended</option>
          <option value="absent">Absent</option>
        </select>
      ) : (
        <span className={`px-3 py-1 rounded-full text-sm ${
          member.attendanceStatus === "pending"
            ? "bg-yellow-50 text-yellow-700 border border-yellow-200"
            : member.attendanceStatus === "attended"
            ? "bg-green-50 text-green-700 border border-green-200"
            : "bg-red-50 text-red-700 border border-red-200"
        }`}>
          {member.attendanceStatus}
        </span>
      )}
    </div>
  </div>
);

export default EventMembers; 